import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../api";

const StoreContext = createContext(null);
export const useStore = () => useContext(StoreContext);

export const StoreProvider = ({ children }) => {
  const [products, setProducts] = useState([]);
  const [sections, setSections] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const [p, s] = await Promise.all([
        api.get("/store/products"),
        api.get("/store/sections"),
      ]);
      setProducts(p.data || []);
      setSections(s.data || []);
    } catch (e) {
      console.error("Store load failed", e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const getProduct = (slug) => products.find((p) => p.slug === slug);
  const getByCategory = (key) => products.filter((p) => (p.categories || []).includes(key));
  const bestsellers = products.filter((p) => (p.tags || []).includes("bestseller"));
  const newArrivals = products.filter((p) => p.badge === "New" || ["l-threonate", "ecdysterone", "plant-sterols", "artichoke"].includes(p.id)).slice(0, 4);
  const saleItems = products.filter((p) => (p.categories || []).includes("sale"));
  const bundleItems = products.filter((p) => (p.categories || []).includes("bundles"));

  return (
    <StoreContext.Provider value={{ products, sections, loading, getProduct, getByCategory, bestsellers, newArrivals, saleItems, bundleItems, reload: load }}>
      {children}
    </StoreContext.Provider>
  );
};
